import { baseApi } from 'src/utils'
import { GetCompanyParams } from './types'
import { API_ENDPOINTS } from './api-endpoints'

export const getTransportationZone = (Id: string, businessPartnerId: string) =>
  baseApi
    .get(API_ENDPOINTS.common.transportationZone(Id), {
      params: { businessPartnerId },
    })
    .then((res) => res.data)

export const getTaskList = () =>
  baseApi.get(API_ENDPOINTS.common.taskList).then((res) => res.data)

export const getMenuItems = () =>
  baseApi.get(API_ENDPOINTS.common.menu).then((res) => res.data)

export const getCompanies = (params?: GetCompanyParams) =>
  baseApi.get(API_ENDPOINTS.common.company, { params }).then((res) => res.data)

export const getClientDetailsById = (
  id: string,
  params?: { companyId?: string[]; salesAreaId?: string }
) =>
  baseApi
    .get(API_ENDPOINTS.businessPartner.byId(id), { params })
    .then((res) => res.data)
